<template>
    <Question question="Signature">
        <div style="text-align: center">
            <p>Capturing your signature allows us to quickly file signed VA documents on your behalf.</p>
            <p>If you consent to e-signatures, please sign in the dotted box below:</p>
            <canvas id="signature"
                @mousemove="draw"        
                @mousedown="setPosition" 
                @mouseenter="setPosition"
                @touchstart="fireMouseEvent($event)"
                @touchend="fireMouseEvent($event)"
                @touchmove="fireMouseEvent($event)"/>
                <p>Note: You may need to rotate your device in order to sign when on a mobile device.</p>
                <button type="button" @click="clear" class="btn btn-danger">Clear</button>                               
        </div>


    </Question>
</template>
<style scoped>
#signature {
    border-style: dotted;
}
</style>
<script>
import Question from './Question.vue'
export default {
  name: 'Signature',
  components: {
      Question
  },
  data: function() {
    return {
        x: 0,
        y: 0,
        canvas: document.getElementById("signature")
    };
  },
  created: function() {
    this.$on('save', function() {
        this.$parent.$emit('veteranRelationshipChanged', this.relationship);
    });
  },
  methods: {
    setPosition(e) {
        let rect = e.currentTarget.getBoundingClientRect();        
        this.x = e.clientX - Math.round(rect.left);
        this.y = e.clientY - Math.round(rect.top);
    },
    draw(e) {
        // mouse left button must be pressed
        if (e.buttons !== 1) return;      

        let canvas = document.getElementById("signature");

        let ctx = canvas.getContext('2d');

        ctx.beginPath(); // begin
        ctx.lineWidth = 2;

        ctx.moveTo(this.x, this.y); 
        this.setPosition(e);
        ctx.lineTo(this.x, this.y);
        ctx.stroke(); 
    },
    clear() {
        let canvas = document.getElementById("signature");
        let ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
    },
    fireMouseEvent(e) {
        let canvas = document.getElementById("signature");    
        e.preventDefault();
        e.stopPropagation();    
        let mouseEvent, touch;
        switch(e.type) {
            case "touchmove":
                touch = e.touches[0];
                mouseEvent = new MouseEvent("mousemove", {
                    clientX: touch.clientX,
                    clientY: touch.clientY,
                    currentTarget: e.target,
                    buttons: 1
                });             
                canvas.dispatchEvent(mouseEvent);   
                break;
            case "touchstart":
                touch = e.touches[0];
                mouseEvent = new MouseEvent("mousedown", {
                    clientX: touch.clientX,
                    clientY: touch.clientY
                });
                canvas.dispatchEvent(mouseEvent);       
                break;                
        }
    }
  }

}
</script>